module.exports = __webpack_public_path__ + "static/media/youtube.687c5721.svg";